<template>
  <VModal name="template-replace-modal" :loading="loading">
    <template v-slot:header>
      <h2 class="o-modal__box__header">
        {{ $t('template.replaceTemplate.replaceTemplate') }}
      </h2>
    </template>
    <template v-slot:content>
      <h4>{{ $t('template.replaceTemplate.description') }}</h4>
      <TWFilePicker
        :uploaderMessage="uploaderMessageText"
        accept=".pdf,.docx,.doc,.xlsx,.xls"
        @add="uploadHandler"
        data-ec="templates_replace_template_modal"
        data-et="file_uploader" />
      <br />
      <VMessage
        type="info"
        subtype="outlined"
        :fullwidth="true">
        <template v-slot:icon>
          <InfoCircleIcon />
        </template>
        <template v-slot:text>
          {{ $t('templates.onlyFileTypesWarning') }}
        </template>
      </VMessage>
    </template>
  </VModal>
</template>

<script>
import VMessage from '@/components/deprecated/atoms/Message.vue';
import TWFilePicker from '@/components/tailwind/FilePicker.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import HTTP from '@/utils/http';
import { InfoCircleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'ReplaceTemplateModal',
  props: {
    template: {
      type: [Object],
      required: true,
    },
  },
  components: {
    VMessage,
    TWFilePicker,
    VModal,
    InfoCircleIcon,
  },
  data() {
    return {
      loading: false,
      http: null,
    };
  },
  computed: {
    uploaderMessageText() {
      return screen.width < 500 ? this.$t('functional.uploaderMessageMobile'): this.$t('functional.uploaderMessage'); // eslint-disable-line
    },
  },
  created() {
    this.http = HTTP;
  },
  methods: {
    async uploadHandler([file]) {
      this.loading = true;
      await this.$store.dispatch('template/REPLACE', { file, fingerprint: this.template.fingerprint });
      const { fingerprint } = this.$store.getters['template/selected'];
      this.goToEditPage(fingerprint);
      this.loading = false;
    },
    goToEditPage(fingerprint) {
      this.$router.push({
        path: `/templates/${fingerprint}/edit`,
      });

      this.$bus.$emit('closeModal');
      this.$bus.$emit('renderGlobalMessage', ({ message: this.$t('message.success.uploaded', { name: 'template' }), icon: 'check', type: 'success' }));
    },
  },
};
</script>

<style scoped>
.check-label {
  display: inline-block !important;
  vertical-align: super;
  margin-left: var(--spacing-small);
}

.m-uploader {
  height: 120px;
}
</style>
